import './bootstrap';

console.log("app.js loaded");

// gsap is only needed for a handful of user-triggered animations (the live
// pricing dropdown toggle, the WhatsApp bubble reveal/dismiss). Loading it
// as a separate chunk keeps it out of the initial JS payload every page pays
// for, fetching it only when one of those interactions actually happens.
let gsapPromise = null;
function loadGsap() {
    return gsapPromise ?? (gsapPromise = import('gsap').then((mod) => mod.gsap));
}

const mobileMaxWidth = 767;
const html = document.documentElement;
const body = document.body;

//mobile screen size detect
window.isMobile = (window.innerWidth <= mobileMaxWidth);

window.csrfToken = () =>
{
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

const recaptchaSiteKeyMeta = document.querySelector('meta[name="recaptcha-site-key"]');
const recaptchaSiteKey = recaptchaSiteKeyMeta?.getAttribute('content');

window.loadReCaptcha = function (callback)
{
    if (typeof grecaptcha !== 'undefined')
    {
        callback();
        return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = callback;
    document.head.appendChild(script);
}

const preventBodyScroll = () =>
{
    body.classList.add('noscroll');
}
const allowBodyScroll = () =>
{
    body.classList.remove('noscroll');
}

window.stripTags = (html) =>
{
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

//Modals
window.showModal = function(modal_id)
{
    const modal = document.querySelector("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    if (modal)
    {
        modal.classList.add("visible");
        modal.dispatchEvent(new Event('show'));
        const focusField = modal.querySelector("[data-focus-on-show-modal]");
        if (focusField)
        {
            focusField.focus();
        }
    }
}

window.hideModal = function(modal_id = null)
{
    let modals, modal_to_close;
    if (modal_id!==null)
    {
        modal_to_close = document.querySelectorAll("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    }
    else
    {
        modals = document.querySelectorAll("#modals_container .modal");

        for (let modal of modals)
        {
            const rect = modal.getBoundingClientRect();

            // Check the center point of the modal
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const topElement = document.elementFromPoint(centerX, centerY);

            // Check if the modal is the topmost at its own center
            if (modal.contains(topElement) || modal === topElement)
            {
                modal_to_close = modal;
            }
        }
    }
    modal_to_close.classList.remove("visible");
    modal_to_close.dispatchEvent(new Event('hide'));
}

window.modal = function(content,title = null, rich = false)
{
    const dynamic_modal = document.querySelector("#modals_container .modal[data-modal-id=\"dynamic\"]");
    if (!rich)
    {
        content = "<p>"+content+"</p>";
    }
    if (title==null)
    {
        title = "Message";
    }
    dynamic_modal.querySelector(".modal_header > h4 > span").innerHTML = title;
    dynamic_modal.querySelector(".modal_content").innerHTML = content;
    window.showModal('dynamic');
}

window.richModal = function(content,title = null)
{
    window.modal(content,title,true);
}

//lazy load

window.fadeLazyLoadImage = function (image)
{
    if (image.complete)
    {
        // If the image is already loaded from cache, add loaded class immediately
        image.classList.add("loaded");
    }
    else
    {
        image.addEventListener("load", () =>
        {
            image.decode().then(() => {
                image.classList.add("loaded");
            }).catch(() => {
                // If something went wrong, add loaded class anyway
                image.classList.add("loaded");
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {

    //mobile screen size detector
    window.addEventListener('resize', () => {
        window.isMobile = (window.innerWidth <= mobileMaxWidth);
    });

    //announcement banner dismiss / snooze
    const announcementBanner = document.querySelector('#announcement_banner');
    if (announcementBanner)
    {
        const announcementId = announcementBanner.getAttribute('data-announcement-id');
        const announcementVersion = announcementBanner.getAttribute('data-announcement-version');
        const snoozeHours = parseInt(announcementBanner.getAttribute('data-snooze-hours'), 10);
        // version (updated_at) is folded into the key so editing an announcement's content
        // re-shows it even to visitors who had already dismissed the previous version.
        const snoozeKey = 'announcement_dismissed_until_' + announcementId + '_' + announcementVersion;
        const dismissedUntil = parseInt(localStorage.getItem(snoozeKey), 10);

        if (dismissedUntil && dismissedUntil > Date.now())
        {
            announcementBanner.classList.add('hidden');
        }
        else
        {
            const dismissButton = announcementBanner.querySelector('[data-dismiss-announcement]');
            if (dismissButton)
            {
                dismissButton.addEventListener('click', () => {
                    localStorage.setItem(snoozeKey, String(Date.now() + (snoozeHours * 60 * 60 * 1000)));
                    announcementBanner.classList.add('hidden');
                });
            }
        }
    }

    //whatsapp bubble - show after a short delay, snooze on dismiss
    const whatsappBubble = document.querySelector('[data-whatsapp-bubble]');
    if (whatsappBubble)
    {
        const whatsappSnoozeKey = 'whatsapp_bubble_dismissed_until';
        const whatsappSnoozeHours = 24;
        const whatsappDismissedUntil = parseInt(localStorage.getItem(whatsappSnoozeKey), 10);
        const whatsappReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const dismissWhatsappBubble = () => {
            if (whatsappReducedMotion)
            {
                whatsappBubble.classList.remove('is-visible');
                return;
            }

            loadGsap().then((gsap) => {
                gsap.to(whatsappBubble, {
                    opacity: 0,
                    y: 8,
                    duration: 0.3,
                    ease: 'power2.in',
                    onComplete: () => whatsappBubble.classList.remove('is-visible'),
                });
            });
        };

        if (!whatsappDismissedUntil || whatsappDismissedUntil <= Date.now())
        {
            setTimeout(() => {
                whatsappBubble.classList.add('is-visible');

                if (whatsappReducedMotion)
                {
                    whatsappBubble.style.opacity = 1;
                    whatsappBubble.style.transform = 'translateY(0)';
                    return;
                }

                loadGsap().then((gsap) => {
                    gsap.fromTo(whatsappBubble,
                        { opacity: 0, y: 12 },
                        { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }
                    );
                });
            }, 5000);
        }

        const whatsappCloseButton = whatsappBubble.querySelector('[data-dismiss-whatsapp-bubble]');
        if (whatsappCloseButton)
        {
            whatsappCloseButton.addEventListener('click', () => {
                localStorage.setItem(whatsappSnoozeKey, String(Date.now() + (whatsappSnoozeHours * 60 * 60 * 1000)));
                dismissWhatsappBubble();
            });
        }
    }

    //modal show / hide events
    document.addEventListener('click',(event) => {
        if (event.target)
        {
            const modalTrigger = event.target.closest('[data-show-modal]');
            if (modalTrigger)
            {
                event.preventDefault();
                window.showModal(modalTrigger.getAttribute('data-show-modal'));
            }
        }
    });
    document.addEventListener('mousedown',(event) => { //needs mousedown for close to stop accidental drags off modal closing it
        if (event.target)
        {
            //check for clicks inside closeable modal
            const modalOuters = document.querySelectorAll("aside.modal.closeable");

            modalOuters.forEach(modalOuter => {
                if (modalOuter.contains(event.target))
                {
                    const modalInner = modalOuter.querySelector(".modal_inner");
                    if (!modalInner.contains(event.target) || event.target.classList.contains('modal_close_button'))
                    {
                        window.hideModal();
                    }
                }
            });
        }
    });

    //hide on escape being pressed
    document.addEventListener("keyup", function(event) {
        if (event.key === "Escape") {
            const modals = document.querySelectorAll("aside.modal");
            modals.forEach(modal => {
                if (modal.classList.contains("visible"))
                {
                    window.hideModal();
                }
            });
        }
    });

    
    //lazy loading images fade in
    document.querySelectorAll('img[loading="lazy"]').forEach(image => {
        window.fadeLazyLoadImage(image);
    });

    // Ajax Form Submissions
    (function initAjaxForms() {
        const forms = document.querySelectorAll('form[data-action-ajax]');
        if (!forms.length) return;

        const clearErrors = (form) => {
            form.querySelectorAll('.field-error, .form-error, .input-error').forEach(n => n.remove());
            form.querySelectorAll('.has_error, .error').forEach(el => el.classList.remove('has_error', 'error'));
            form.querySelectorAll('[aria-invalid="true"]').forEach(el => el.setAttribute('aria-invalid', 'false'));
        };

        const showErrors = (form, errors = {}) => {
            // Top-level summary for non-field errors
            const generalErrors = [];

            Object.entries(errors || {}).forEach(([field, messages]) => {
                const msgs = Array.isArray(messages) ? messages : [String(messages)];
                // Try to find input by name
                const input = form.querySelector(`[name="${CSS.escape(field)}"]`);
                if (input && input.type !== 'hidden') {
                    const err = document.createElement('p');
                    err.className = 'field-error';
                    err.textContent = msgs[0];
                    // mark container if possible
                    const container = input.closest('.input-group, .form_group, .form-group, .field, .input');
                    (container || input).classList.add('has_error');
                    input.setAttribute('aria-invalid', 'true');
                    // insert error after the input
                    (container || input.parentElement || form).appendChild(err);
                } else {
                    generalErrors.push(...msgs);
                }
            });

            if (generalErrors.length) {
                const g = document.createElement('div');
                g.className = 'form-error';
                g.innerHTML = generalErrors.map(m => `<p>${m}</p>`).join('');
                form.prepend(g);
            }

            // Focus first invalid input
            const firstInvalid = form.querySelector('[aria-invalid="true"]');
            if (firstInvalid) firstInvalid.focus({preventScroll: false});
        };

        const showSuccess = (form, payload = {}) => {
            const title = payload.title || form.getAttribute('data-success-title') || 'Thank you';
            const message = payload.message || form.getAttribute('data-success-message') || 'Your submission has been received.';
            const html = payload.html;

            const wrapper = document.createElement('div');
            wrapper.className = 'form-success';
            wrapper.setAttribute('role', 'status');
            wrapper.setAttribute('aria-live', 'polite');
            wrapper.setAttribute('tabindex', '-1'); // allow programmatic focus
            wrapper.innerHTML = html || `<h3>${title}</h3>${message}`;

            // Replace the form with the success message
            form.replaceWith(wrapper);

            // Scroll the success message into view accounting for fixed header
            const scrollToTopOf = (el) => {
                if (!el) return;
                try {
                    const header = document.getElementById('page_header');
                    const headerOffset = header ? header.offsetHeight : 0;
                    const rect = el.getBoundingClientRect();
                    const absoluteTop = rect.top + window.pageYOffset - (headerOffset + 16); // 16px breathing room
                    window.scrollTo({top: Math.max(absoluteTop, 0), behavior: 'smooth'});
                } catch (e) {
                    el.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
                try { el.focus({preventScroll: true}); } catch (e) {}
            };

            // Allow layout/styles to settle
            setTimeout(() => scrollToTopOf(wrapper), 50);
        };

        const performAjax = async (form) => {
            clearErrors(form);

            try {
                const url = form.getAttribute('action') || window.location.href;
                let method = (form.getAttribute('method') || 'GET').toUpperCase();

                const formData = new FormData(form);

                // method spoofing via _method
                const spoof = formData.get('_method');
                if (spoof) method = String(spoof).toUpperCase();

                let fetchUrl = url;
                let fetchOpts = {
                    method,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                };

                if (method === 'GET' || method === 'HEAD') {
                    const qs = new URLSearchParams(formData).toString();
                    fetchUrl = qs ? `${url}${url.includes('?') ? '&' : '?'}${qs}` : url;
                } else {
                    fetchOpts.body = formData; // includes _token
                    // CSRF header fallback
                    fetchOpts.headers['X-CSRF-TOKEN'] = window.csrfToken();
                }

                const res = await fetch(fetchUrl, fetchOpts);
                const isJson = (res.headers.get('content-type') || '').includes('application/json');
                let data = null;
                try {
                    data = isJson ? await res.json() : null;
                } catch {
                    data = null;
                }

                if (!res.ok) {
                    // Laravel may send 422 with errors
                    const errs = data && data.errors ? data.errors : {general: ['We couldn’t submit your form due to a server error. Please try again, or contact us if the problem persists.']};
                    showErrors(form, errs);
                    return;
                }

                // Success path; handle conventional shapes
                if (data && (data.success || data.status === 'ok')) {

                    if (data.redirect) {
                        window.location.href = data.redirect;
                        return;
                    }

                    showSuccess(form, {title: data.data.title, message: data.data.message});
                } else if (data && data.errors) {
                    showErrors(form, data.errors);
                } else {
                    // Fallback: treat as success
                    showSuccess(form, {});
                }

            } catch (err) {
                console.error('[Form AJAX] Submission error:', err);
                showErrors(form, {general: ['An unexpected error occurred. Please try again.']});
            }
        };

        // Attach listener
        forms.forEach(form => {

            form.addEventListener('invalid', () => {
                form.classList.add('submitted');
            }, true);

            const FIELD_WRAPPER = '.input-group, .form_group, .form-group, .field, .input';
            const clearFieldError = (input) => {
                if (!input) return;
                if (input.getAttribute('aria-invalid') === 'true') {
                    input.setAttribute('aria-invalid', 'false');
                }
                const container = input.closest(FIELD_WRAPPER);
                const scope = container || input.parentElement || form;
                scope.querySelectorAll('.field-error').forEach(el => {
                    if (!container || container.contains(el)) el.remove();
                });
                if (container) container.classList.remove('has_error', 'error', 'invalid');
                const anyInvalid = form.querySelector('[aria-invalid="true"], :invalid');
                if (!anyInvalid) form.classList.remove('submitted');
            };

            // Validate clear affect
            const shouldClear = (el) => {
                if (!el) return false;
                if (el.type === 'checkbox') return el.checked;
                if (el.type === 'radio') {
                    const group = form.querySelectorAll(`input[type="radio"][name="${CSS.escape(el.name)}"]`);
                    return Array.from(group).some(r => r.checked);
                }
                if (el.tagName === 'SELECT') return el.value !== '' && el.value != null;
                const val = (el.value || '').trim();
                return el.checkValidity() || (!!val && el.hasAttribute('required'));
            };

            // Clear inputs once changed.
            const handleMaybeClear = (target) => {
                const input = target && target.closest('input, textarea, select');
                if (!input || !form.contains(input)) return;
                if (shouldClear(input)) {
                    clearFieldError(input);
                }
            };

            form.addEventListener('input', (e) => handleMaybeClear(e.target), true);
            form.addEventListener('change', (e) => handleMaybeClear(e.target), true);

            // Submit handler
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Immediately disable the submit button to prevent double clicks
                const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
                const prevText = submitBtn && (submitBtn.value || submitBtn.textContent);
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.setAttribute('aria-busy', 'true');
                    if ('value' in submitBtn && submitBtn.value) submitBtn.value = 'Please wait...';
                    else submitBtn.textContent = 'Please wait...';
                }

                // Prevent parallel submissions per form (race conditions when multiple forms exist)
                if (form.dataset.submitting === '1') {
                    // If already submitting, keep the button disabled; do not proceed
                    return;
                }
                form.dataset.submitting = '1';

                const restoreSubmitButton = () => {
                    delete form.dataset.submitting;
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.removeAttribute('aria-busy');
                        if (prevText) {
                            if ('value' in submitBtn && submitBtn.value) submitBtn.value = prevText;
                            else submitBtn.textContent = prevText;
                        }
                    }
                };

                if (form.hasAttribute('data-captcha')) {
                    // Determine a stable, form-specific reCAPTCHA action for better attribution
                    const recaptchaAction = (
                        form.getAttribute('data-recaptcha-action') ||
                        form.getAttribute('name') ||
                        form.id ||
                        'submit'
                    ).toString().toLowerCase().replace(/[^a-z0-9_\-.]/g, '-').slice(0, 100);

                    const ensureToken = () => new Promise((resolve, reject) => {
                        if (!window.grecaptcha || !recaptchaSiteKey) return reject(new Error('reCAPTCHA not configured'));
                        grecaptcha.ready(() => {
                            // Use a per-form action to ensure correct association on the backend and avoid cross-form confusion
                            grecaptcha.execute(recaptchaSiteKey, {action: recaptchaAction})
                                .then(token => {
                                    let input = form.querySelector('input[name="g-recaptcha-response"]');
                                    if (!input) {
                                        input = document.createElement('input');
                                        input.type = 'hidden';
                                        input.name = 'g-recaptcha-response';
                                        form.appendChild(input);
                                    }
                                    input.value = token;
                                    resolve();
                                })
                                .catch(reject);
                        });
                    });
                    try {
                        await ensureToken();
                        await performAjax(form);
                    } catch (err) {
                        if (typeof loadReCaptcha === 'function') {
                            await new Promise(result => loadReCaptcha(async () => {
                                try {
                                    await ensureToken();
                                } catch {
                                    // Silently fail
                                }
                                result();
                            }));
                            await performAjax(form);
                        } else {
                            console.warn('[Form AJAX] reCAPTCHA not available; continuing without token.');
                            await performAjax(form);
                        }
                    } finally {
                        restoreSubmitButton();
                    }
                } else {
                    try {
                        await performAjax(form);
                    } finally {
                        restoreSubmitButton();
                    }
                }
            });
        });
    })();
});

var nav_open = false;

function showNav() {
    document.querySelectorAll("header .js-menu-btn, nav.nav_mobile, header button.hamburger")
            .forEach(function(el) { el.classList.add("is-active"); });
    document.documentElement.classList.add("noscroll");
    document.body.classList.add("noscroll");
    nav_open = true;
}

function hideNav() {
    document.querySelectorAll("header .js-menu-btn, nav.nav_mobile, header button.hamburger")
            .forEach(function(el) { el.classList.remove("is-active"); });
    document.documentElement.classList.remove("noscroll");
    document.body.classList.remove("noscroll");
    document.querySelectorAll(".nav_mobile li.has_children")
            .forEach(function(el) { el.classList.remove("open"); });
    document.querySelector(".nav_mobile")?.classList.remove("subnav_open");
    nav_open = false;
}

function toggleNav() {
    if (!nav_open)
    {
        showNav();
    }
    else
    {
        hideNav();
    }
}

document.querySelector(".js-menu-btn").addEventListener("click", function() {
    toggleNav();
});

document.addEventListener("DOMContentLoaded", function() {

    var allItems = document.querySelectorAll(".js-mobile-has-children");

    document.querySelectorAll(".js-mobile-has-children > a").forEach(function(el) {
        el.addEventListener("click", function(e) {
            e.preventDefault();

            var parentLi = this.parentElement;
            var submenu = parentLi.querySelector(":scope > ul");
            var isActive = parentLi.classList.contains("is-active");

            // close all items first (and collapse their submenus)
            allItems.forEach(function(item) {
                item.classList.remove("is-active");
                var itemSubmenu = item.querySelector(":scope > ul");
                if (itemSubmenu) {
                    itemSubmenu.style.maxHeight = "0px";
                }
            });

            // if the clicked one wasn't already open, open it
            if (!isActive) {
                submenu.style.maxHeight = submenu.scrollHeight + "px";
                parentLi.classList.add("is-active");
            }

        });
    });

});

document.addEventListener("DOMContentLoaded", function() {

    var livePrices = document.querySelector("[data-live-prices]");

    if (livePrices) {
        var livePricesBody = livePrices.querySelector("[data-live-prices-body]");
        var livePricesToggles = livePrices.querySelectorAll("[data-live-prices-toggle]");
        var livePricesReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var livePricesOpenClip = "inset(0px 0px 0% 0px)";
        var livePricesClosedClip = "inset(0px 0px 100% 0px)";

        // clip-path only affects paint, never the element's own geometry, so unlike
        // height (which shows up as a layout shift even set instantly, since the body
        // existed at height:0 in the very first rendered frame) it can't register as one.
        var openLivePrices = function(animate) {
            livePrices.classList.add("is-open");
            livePricesToggles.forEach(function(toggle) { toggle.setAttribute("aria-expanded", "true"); });

            if (!animate || livePricesReducedMotion) {
                livePricesBody.style.clipPath = livePricesOpenClip;
                return;
            }

            loadGsap().then(function(gsap) {
                gsap.to(livePricesBody, { clipPath: livePricesOpenClip, duration: 0.5, ease: "power2.inOut" });
            });
        };

        var closeLivePrices = function() {
            livePrices.classList.remove("is-open");
            livePricesToggles.forEach(function(toggle) { toggle.setAttribute("aria-expanded", "false"); });

            if (livePricesReducedMotion) {
                livePricesBody.style.clipPath = livePricesClosedClip;
                return;
            }

            loadGsap().then(function(gsap) {
                gsap.to(livePricesBody, { clipPath: livePricesClosedClip, duration: 0.4, ease: "power2.inOut" });
            });
        };

        livePricesToggles.forEach(function(toggle) {
            toggle.addEventListener("click", function() {
                if (livePrices.classList.contains("is-open")) {
                    closeLivePrices();
                } else {
                    openLivePrices(true);
                }
            });
        });

        // Auto-open only on a visitor's first landing on the homepage in a rolling 24
        // hours - the timestamp is written the moment it's shown, not when it's dismissed,
        // so closing it straight away doesn't make it pop open again on the next homepage
        // visit inside that window. Mirrors the announcement banner's snooze pattern above.
        if (livePrices.getAttribute("data-homepage") === "1") {
            var seenKey = "live_prices_dropdown_seen_until";
            var seenUntil = parseInt(localStorage.getItem(seenKey), 10);

            if (!seenUntil || seenUntil <= Date.now()) {
                openLivePrices(false);
                localStorage.setItem(seenKey, String(Date.now() + (24 * 60 * 60 * 1000)));
            }
        }
    }

    var allButtons = document.querySelectorAll(".js-footer-nav-btn");

    allButtons.forEach(function(btn) {
        btn.addEventListener("click", function(e) {
            e.preventDefault();

            var content = this.nextElementSibling; // .js-footer-nav-content
            var isActive = this.classList.contains("is-active");

            // close all buttons/content first (and collapse their content)
            allButtons.forEach(function(button) {
                button.classList.remove("is-active");
                var buttonContent = button.nextElementSibling;
                if (buttonContent) {
                    buttonContent.classList.remove("is-active");
                    buttonContent.style.maxHeight = "0px";
                }
            });

            // if the clicked one wasn't already open, open it
            if (!isActive) {
                content.style.maxHeight = content.scrollHeight + "px";
                content.classList.add("is-active");
                this.classList.add("is-active");
            }

        });
    });

});

document.addEventListener("DOMContentLoaded", function() {

    var closeTimer = null;
    var openItem = null;

    document.querySelectorAll(".nav_desktop li.has_children").forEach(function(item) {
        item.addEventListener("mouseenter", function() {
            clearTimeout(closeTimer);
            if (openItem && openItem !== item) {
                openItem.classList.remove("is-open");
            }
            item.classList.add("is-open");
            openItem = item;
        });

        item.addEventListener("mouseleave", function() {
            closeTimer = setTimeout(function() {
                item.classList.remove("is-open");
                if (openItem === item) {
                    openItem = null;
                }
            }, 250);
        });
    });

});

// File upload drag-and-drop (opt-in via data-drag-area)
const fileUploadGenericIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2h9l5 5v15H6z"/><path d="M15 2v5h5"/></svg>';
const fileUploadRemoveIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

document.querySelectorAll('[data-file-upload][data-drag-area]').forEach(wrapper => {
    const input = wrapper.querySelector('[data-file-upload-input]');
    const dropzone = wrapper.querySelector('[data-file-upload-dropzone]');
    const previews = wrapper.querySelector('[data-file-upload-previews]');
    const message = wrapper.querySelector('[data-file-upload-message]');
    if (!input || !dropzone) return;

    const defaultMessage = message ? message.textContent : '';
    let previewUrls = [];
    let rejectTimeout = null;

    const acceptedExtensions = () => (input.getAttribute('accept') || '')
        .split(',')
        .map(ext => ext.trim().toLowerCase())
        .filter(Boolean);

    const isFileAccepted = (file, extensions) => {
        if (!extensions.length) return true;
        const dotIndex = file.name.lastIndexOf('.');
        if (dotIndex === -1) return false;
        return extensions.includes(file.name.slice(dotIndex).toLowerCase());
    };

    const showRejected = (extensions) => {
        dropzone.classList.add('is-rejected');
        if (message) {
            message.textContent = extensions.length
                ? `Unsupported file type - please use ${extensions.join(', ')}`
                : 'Unsupported file type';
        }
        clearTimeout(rejectTimeout);
        rejectTimeout = setTimeout(() => {
            dropzone.classList.remove('is-rejected');
            if (message) message.textContent = defaultMessage;
        }, 2500);
    };

    const renderPreviews = () => {
        if (!previews) return;

        previewUrls.forEach(url => URL.revokeObjectURL(url));
        previewUrls = [];

        const files = Array.from(input.files || []);

        previews.innerHTML = files.map((file, index) => {
            const name = window.stripTags(file.name);
            let thumb;

            if (file.type && file.type.startsWith('image/')) {
                const url = URL.createObjectURL(file);
                previewUrls.push(url);
                thumb = `<img src="${url}" alt="">`;
            } else {
                thumb = fileUploadGenericIcon;
            }

            return `<div class="file-upload_preview">
                <button type="button" class="file-upload_preview_remove" data-file-upload-remove="${index}" aria-label="Remove file">${fileUploadRemoveIcon}</button>
                <div class="file-upload_preview_thumb">${thumb}</div>
                <div class="file-upload_preview_name">${name}</div>
            </div>`;
        }).join('');

        previews.hidden = files.length === 0;
    };

    const removeFileAt = (index) => {
        const remaining = new DataTransfer();
        Array.from(input.files || []).forEach((file, i) => {
            if (i !== index) remaining.items.add(file);
        });
        input.files = remaining.files;
        input.dispatchEvent(new Event('change', {bubbles: true}));
    };

    previews?.addEventListener('click', (e) => {
        const button = e.target.closest('[data-file-upload-remove]');
        if (!button) return;
        e.preventDefault();
        e.stopPropagation();
        removeFileAt(Number(button.dataset.fileUploadRemove));
    });

    dropzone.addEventListener('click', () => input.click());

    ['dragover', 'dragenter'].forEach(evt =>
        dropzone.addEventListener(evt, (e) => {
            e.preventDefault();
            dropzone.classList.add('is-dragging');
        })
    );

    ['dragleave', 'dragend'].forEach(evt =>
        dropzone.addEventListener(evt, () => dropzone.classList.remove('is-dragging'))
    );

    dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropzone.classList.remove('is-dragging');

        const droppedFiles = Array.from(e.dataTransfer?.files || []);
        if (!droppedFiles.length) return;

        const extensions = acceptedExtensions();
        if (!droppedFiles.every(file => isFileAccepted(file, extensions))) {
            showRejected(extensions);
            return;
        }

        input.files = e.dataTransfer.files;
        input.dispatchEvent(new Event('change', {bubbles: true}));
    });

    input.addEventListener('change', renderPreviews);
});